import type { CompanyAddress } from "../../../hooks/use-companies";

export function formatAddress(addr: CompanyAddress): string {
	const parts = [
		addr.addressName2,
		addr.addressName3,
		addr.street,
		addr.postalCode,
		addr.city,
		addr.state,
		addr.country,
	].filter((p): p is string => !!p && p.trim().length > 0);
	return parts.join(" ").slice(0, 254);
}
